import {Component, OnInit} from '@angular/core';
import {ComponentAsElement} from '../../../services/common/bootstrap/annotation/component-as-element';
import {TranslationService} from '../../../services/translation.service';

@ComponentAsElement('v-develop-sandbox-element')
@Component({
  selector: 'v-develop-sandbox',
  templateUrl: './develop-sandbox.component.html',
  styleUrls: []
})
export class DevelopSandboxComponent implements OnInit {

  constructor(private translation: TranslationService) {
  }

  ngOnInit(): void {
    this.translation.setTranslation('pl', 'PL');
  }


}
